/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import * as React from 'react';
import { t, Strings } from '@apitable/core';
import styles from './style.module.less';
import { Popup } from 'pc/components/common/mobile/popup';
import { ViewSwitcher } from 'pc/components/tool_bar/mobile/view_switcher';

interface IViewMenu {
  visible: boolean;
  onClose: () => void;
}

export const ViewMenu: React.FC<React.PropsWithChildren<IViewMenu>> = props => {
  const {
    visible,
    onClose,
  } = props;

  return (
    <Popup
      className={styles.viewMenuDrawer}
      title={t(Strings.view_list)}
      open={visible}
      onClose={onClose}
      height='auto'
      destroyOnClose
      bodyStyle={{ padding: '0 0 24px 24px' }}
    >
      <ViewSwitcher onClose={onClose} />
    </Popup>
  );
};
